import CardSection from '../sections/CardSection';
import InputField  from '../form/InputField';
import SelectField from '../form/SelectField';

export default function VehicleSoatSection({ 
    data, 
    empresasSeguros,
    onChange, 
    errors 
}) {
    const companiaSoatOptions = Array.isArray(empresasSeguros)
        ? empresasSeguros.map(item => ({
            value: item.codigo,
            label: item.descripcion
        }))
        : [];

    // Fecha de hoy en formato YYYY-MM-DD, para usar como máximo
    const today = new Date().toISOString().split('T')[0];

    return (
        <CardSection icon="engineering" title="SOAT y Técnico-Mecánica">
            <div className="row">
                <div className="col-md-4">
                    <SelectField
                        id="companiaSoat"
                        label="Compañía SOAT"
                        options={companiaSoatOptions}
                        required
                        value={data.companiaSoat}
                        onChange={onChange}
                        error={errors.companiaSoat}
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="numeroPolizaSoat"
                        label="N° Póliza SOAT"
                        placeholder="Ingrese número"
                        uppercase
                        required
                        value={data.numeroPolizaSoat}
                        onChange={onChange}
                        error={errors.numeroPolizaSoat}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="numeroRevisionTecnicoMecanica"
                        label="N° Revisión Técnico-Mecánica"
                        placeholder="Ingrese número"
                        uppercase
                        required
                        value={data.numeroRevisionTecnicoMecanica}
                        onChange={onChange}
                        error={errors.numeroRevisionTecnicoMecanica}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="fechaExpedicionSoat"
                        label="Fecha Expedición SOAT"
                        type="date"
                        value={data.fechaExpedicionSoat}
                        onChange={onChange}
                        max={today}
                        onKeyDown={e => e.preventDefault()}
                        onPaste={e => e.preventDefault()}
                        error={errors.fechaExpedicionSoat}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="fechaVencimientoSoat"
                        label="Fecha Vencimiento SOAT"
                        type="date"
                        value={data.fechaVencimientoSoat}
                        onChange={onChange}
                        onKeyDown={e => e.preventDefault()}
                        onPaste={e => e.preventDefault()}
                        error={errors.fechaVencimientoSoat}
                    />
                </div>
                <div className="col-md-4">
                    <InputField
                        id="fechaVencimientoRevision"
                        label="Fecha Vencimiento Revisión"
                        type="date"
                        value={data.fechaVencimientoRevision}
                        onChange={onChange}
                        onKeyDown={e => e.preventDefault()}
                        onPaste={e => e.preventDefault()}
                        error={errors.fechaVencimientoRevision}
                    />
                </div>
            </div>
        </CardSection>
    );
}
